import {TreeNode} from '@hconnect/common/types'

import {ItemDetailsLayout} from '../../plant-setup-item-layout'

import {KpiCalculationSettings} from './components'

type KpisProps = {
  selectedItem: TreeNode
}

export const Kpis: React.FC<KpisProps> = ({selectedItem}) => (
  <ItemDetailsLayout>
    <KpiCalculationSettings selectedItem={selectedItem} />
  </ItemDetailsLayout>
)
